import React from "react";
import { Button } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import type { Category } from "types/category";
import martEmptyImg from "assets/images/mart-empty.png";

export type ProductCategoryCardProps = {
  category: Category;
  onEdit: (id: number) => void;
  onDeleteRequest: (id: number) => void;
};

export const ProductCategoryCard: React.FC<ProductCategoryCardProps> = ({
  category,
  onEdit,
  onDeleteRequest,
}) => {
  return (
    <div className="product-category-item-card">
      <div className="product-category-item-image">
        <img
          src={category.logo || martEmptyImg}
          alt={category.name}
          className="product-category-item-image-img"
          onError={(event) => {
            if (!event.currentTarget.src.endsWith(martEmptyImg)) {
              event.currentTarget.src = martEmptyImg;
            }
          }}
        />
      </div>
      <div className="product-category-item-name">{category.name}</div>
      <div className="product-category-item-actions">
        <Button
          type="text"
          size="small"
          icon={<EditOutlined />}
          className="product-category-item-btn product-category-item-btn-edit"
          onClick={() => onEdit(category.id)}
          aria-label="Edit category"
        />
        <Button
          type="text"
          size="small"
          icon={<DeleteOutlined />}
          className="product-category-item-btn product-category-item-btn-delete"
          onClick={() => onDeleteRequest(category.id)}
          aria-label="Delete category"
        />
      </div>
    </div>
  );
};

export default ProductCategoryCard;
